module.exports = __webpack_public_path__ + "img/complispace-logo.4d64a702.png";